import React, { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "dc_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: true, at: new Date().toISOString() }));
    setVisible(false);
  };
  const reject = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: false, at: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-consent" className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:bottom-6 z-40 max-w-md animate-fade-in-up">
      <div className="bg-white border border-slate-200 rounded-2xl shadow-2xl p-6">
        <div className="flex items-start gap-3 mb-4">
          <div className="w-10 h-10 rounded-xl bg-dc-primary/10 text-dc-primary flex items-center justify-center flex-shrink-0">
            <Cookie className="w-5 h-5" strokeWidth={1.6} />
          </div>
          <div className="flex-1">
            <h3 className="font-heading font-bold text-dc-text mb-1">Privacidade & Cookies</h3>
            <p className="text-sm text-slate-600 leading-relaxed">
              Usamos cookies para melhorar sua experiência e analisar o tráfego do site. Ao aceitar, você concorda com nossa Política de Privacidade conforme a LGPD.
            </p>
          </div>
          <button onClick={reject} className="text-slate-400 hover:text-slate-600 -mt-1" aria-label="Fechar">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="flex gap-2">
          <button data-testid="cookie-reject" onClick={reject} className="flex-1 px-4 py-2.5 rounded-full text-sm font-semibold border border-slate-200 hover:bg-slate-50 text-slate-700 transition">
            Apenas essenciais
          </button>
          <button data-testid="cookie-accept" onClick={accept} className="flex-1 px-4 py-2.5 rounded-full text-sm font-semibold bg-dc-primary hover:bg-dc-primary-hover text-white transition shadow-md">
            Aceitar todos
          </button>
        </div>
      </div>
    </div>
  );
}
